const fetchGarageUrl = '/ajax/garage/get-list';
const clearGarageUrl = '/auto-parts/clear-all-cars';

const fetchGarage = ({ data = {}, method = 'POST', error, success }) => {
	return $ajax({
		method,
		dataType: 'json',
		data,
		url: fetchGarageUrl,
		error,
		success,
	});
};

const clearGarage = ({error, success}) => {
	return $ajax({
		method: 'GET',
		url: clearGarageUrl,
		error,
		success,
	});
};

module.exports = {
	fetchGarage,
	clearGarage,
};
